import { useEffect } from "react";
import { Checkbox, TableHeader, TableRow } from "../../components";
import { headersType } from "../../models";
import { archiveAnnualPlanNotification, getAnnualPlanNotifications } from "../../redux/slices/annualPlanSlice";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";

export const headers: headersType[] = [
  {
    title: "Date",
    extraClasses: "w-full pl-0",
    sortKey: "date",
    isClickable: false,
  },
  {
    title: "Patient Name",
    extraClasses: "w-240 pl-0 hidden lg:block",
    sortKey: "name",
    isClickable: false,
  },
  {
    title: "Plan",
    extraClasses: "w-120 pl-0 hidden lg:block",
    sortKey: "planType",
    isClickable: false,
  },
  {
    title: "Payment Frequency",
    extraClasses: "w-140 pl-0 hidden lg:block",
    sortKey: "terms",
    isClickable: false,
  },
  {
    title: "Notification",
    extraClasses: "w-full pl-0",
    sortKey: "notification",
    isClickable: false,
  },
  {
    title: "Archive",
    extraClasses: "w-120 pl-0 block",
    sortKey: "status",
    isClickable: true,
  },
];

const Notifications = () => {
  const { id } = useParams();
  const annualPlanNotifications = useSelector((state: RootState) => state.annualPlan.annualPlanNotifications);
  const notifications = annualPlanNotifications?.content;
  const dispatch = useDispatch<AppDispatch>();
  const extraClasses = headers.map(head => head.extraClasses);
  const handleArchive = (notificationId: string) => {
    if (id) {
      dispatch(archiveAnnualPlanNotification({ officeId: id, notificationId, archive: false })).then(action => {
        if (action.payload) dispatch(getAnnualPlanNotifications({ officeId: id }));
      });
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(getAnnualPlanNotifications({ officeId: id }));
    }
  }, []);

  return (
    <div className="w-full relative">
      {notifications && notifications.length > 0 ? (
        <>
          <div className="flex justify-between items-center border-b border-docnote-blue-light border-opacity-50 ">
            {headers.map((head, index) => (
              <TableHeader
                title={head.title}
                index={index}
                key={index}
                sortIcon={null}
                handleSort={() => null}
                extraClassesHeader={head.extraClasses}
                isClickable={head.isClickable}
              />
            ))}
          </div>
          {notifications?.map((rowData, index) => {
            const planType = rowData.userAnnualPlan.officeAnnualPlan.annualPlanType.name;
            const sortedData = {
              date: moment(rowData.userAnnualPlan.startDate).format("ll"),
              patientName: `${rowData.userAnnualPlan.user.firstName} ${rowData.userAnnualPlan.user.lastName}`,
              planType: planType === "Single" ? "Individual" : planType === "Senior" ? "Senior Individual" : planType,
              terms:
                rowData.userAnnualPlan.officeAnnualPlan.subscription.subscriptionType.charAt(0).toUpperCase() +
                rowData.userAnnualPlan.officeAnnualPlan.subscription.subscriptionType.slice(1),
              notifications: rowData.message,
              status: (
                <div key={index} className={``}>
                  <Checkbox label="" onChange={e => handleArchive(rowData.annualPlanNotificationId)} />
                </div>
              ),
            };
            return (
              <TableRow
                data={Object.values(sortedData)}
                key={0}
                id={""}
                tooltipVisible={false}
                extraClassesRow={extraClasses}
                handleOpenTooltip={() => {}}
                handleCloseTooltip={() => {}}
                tooltipOptions={[]}
                handleTooltipClick={() => {}}
                onRowClick={() => {}}
                rejectedReason={
                  // FIXME: Bit of a hack here with string matching, probably a better way
                  rowData.userAnnualPlan.cancelledReason && rowData.message === "Cancelled annual plan" ? (
                    <p>
                      <b>Reason:</b> {rowData.userAnnualPlan.cancelledReason}
                    </p>
                  ) : null
                }
              />
            );
          })}
        </>
      ) : (
        <p>No notifications have been received</p>
      )}
    </div>
  );
};

export default Notifications;
